import booking from 'api/booking'
import * as types from '../mutation-types'
let token = window.localStorage.getItem('accessToken')

export const fetchArea = ({commit, rootStats}, data) => {
  return booking.area(token).then((data) => {
    // console.log('area', data)
    commit(types.BOOKING_AREA, data)
    return Promise.resolve(data)
  })
}
export const fetchSeatsGuest = ({commit, rootStats}, data) => {
  console.log('fetchSeatsGuest')
  return booking.seats(data).then((data) => {
    commit(types.BOOKING_SEATS, data)
    return Promise.resolve(data)
  })
}
export const fetchSeats = ({commit, rootStats}, data) => {
  return booking.seats(data, token).then((data) => {
    commit(types.BOOKING_SEATS, data)
    return Promise.resolve(data)
  })
}
export const saveSelectedArea = ({commit, rootStats}, data) => {
  commit(types.BOOKING_SELECTED_AREA, data)
}
export const submitBooking = ({commit, rootStats}, data) => {
  return booking.register(token, data).then((data) => {
    commit(types.BOOKING_SEATS, data)
    return Promise.resolve(data)
  })
}



// WEBPACK FOOTER //
// ./src/vuex/booking/actions.js